import { percentageMask } from '@/app/utils/comissionPercentage'
import { BasicInput } from '../../../../../components/BasicInput'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { useEditTableCardController } from './useEditTableCardController'
import { moneyMask } from '@/app/utils/formatMoneyValue'
import { useAuth } from '@/app/hooks/useAuth'
import { cn } from '@/app/utils/cn'
import ValuesAndCommissionsForm from '@/view/components/ValuesAndCommissionsForm'
import { PartnerType } from '@/app/utils/partners.enum'

const LabelField = ({ label, value }: { label: string; value: string }) => {
  return (
    <div>
      <p className="text-sm font-medium">{label}</p>
      <p className="pl-1">{value}</p>
    </div>
  )
}

export const EditTableCard = () => {
  const { handleEditTableSubmit, isPending, methods, selectedTableCard } =
    useEditTableCardController()
  const { isSuperAdmin } = useAuth()

  const percentsValue = methods.watch('percents')
  const percentsNumber = percentsValue
    ? Number(percentsValue.replace(/\D/g, '')) / 100
    : 0
  const isCLT = selectedTableCard.type === 'CLT'
  const isExceedingMax =
    !isSuperAdmin &&
    !isCLT &&
    percentsNumber > (selectedTableCard.maxPercents || 0)

  return (
    <AlertDialog>
      <AlertDialogTrigger>
        <h2 className="text-sm font-medium">Editar</h2>
      </AlertDialogTrigger>

      <AlertDialogContent
        className={cn('w-full p-0', isCLT ? 'max-w-[900px]' : 'max-w-96')}
      >
        <form onSubmit={methods.handleSubmit(handleEditTableSubmit)}>
          <AlertDialogHeader className="p-5">
            <AlertDialogTitle>Editar Tabela</AlertDialogTitle>
          </AlertDialogHeader>

          <div className="border-b-[1px] border-white02" />

          <div className="flex w-full flex-col items-start gap-5 p-5">
            <LabelField label="ID:" value={selectedTableCard.tableCode} />

            {isSuperAdmin ? (
              <BasicInput
                label="Nome"
                name="name"
                placeholder="Escreva o nome da tabela"
                defaultValue={selectedTableCard.name}
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.name?.message}
              />
            ) : (
              <LabelField label="Nome:" value={selectedTableCard.name} />
            )}

            {isCLT && (
              <div className="w-full">
                <p className="mb-4 text-sm text-black04">
                  A comissão do CLT é calculada como uma porcentagem sobre o
                  valor total contratado. O percentual varia conforme o número
                  de parcelas, seguindo as faixas configuradas abaixo.
                </p>
                <ValuesAndCommissionsForm
                  initialValues={selectedTableCard.valuesAndCommissions || []}
                  isOpen={true}
                  partner={PartnerType.CLT}
                  isSuperAdmin={isSuperAdmin}
                />
              </div>
            )}

            <div className={cn('w-full gap-4', isCLT ? 'hidden' : 'flex')}>
              <div className="flex-1">
                <BasicInput
                  label="Comissão"
                  name="percents"
                  placeholder="0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.percents?.message}
                  variant="percentage"
                  onInput={percentageMask}
                />
              </div>

              {!isCLT && (
                <div className="flex-1">
                  <BasicInput
                    label="Bônus"
                    name="bonus"
                    placeholder="0,00"
                    style={{ backgroundColor: '#F7F7F7' }}
                    error={methods.formState.errors.bonus?.message}
                    variant="percentage"
                    onInput={percentageMask}
                  />
                </div>
              )}
            </div>

            <div className={cn('w-full gap-4', isCLT ? 'hidden' : 'flex')}>
              <BasicInput
                label="Comissão Líder"
                name="leaderCommission"
                placeholder="0,00"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.leaderCommission?.message}
                variant="percentage"
                onInput={percentageMask}
              />
            </div>

            {!isSuperAdmin && !isCLT && (
              <p
                className={`text-sm ${isExceedingMax ? 'text-red-500' : 'text-gray-500'}`}
              >
                Máximo: {selectedTableCard.maxPercents}%
              </p>
            )}

            {isSuperAdmin && (
              <div className={cn('gap-4', isCLT ? 'hidden' : 'flex')}>
                <BasicInput
                  label="Limite de emissão"
                  name="limit"
                  placeholder="R$ 0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.limit?.message}
                  onInput={moneyMask}
                />
                <BasicInput
                  label="Máximo"
                  name="maxPercents"
                  placeholder="0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.maxPercents?.message}
                  variant="percentage"
                  onInput={percentageMask}
                />
              </div>
            )}
          </div>

          <AlertDialogFooter className="space-x-2 border-t-[1px] border-white02 p-5">
            <AlertDialogCancel className="w-full rounded-full bg-white02">
              Cancelar
            </AlertDialogCancel>

            <AlertDialogAction
              disabled={isPending || isExceedingMax}
              type="submit"
              className="w-full rounded-full bg-primary text-white"
            >
              Confirmar alterações
            </AlertDialogAction>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
